import type { HeadlineLevel } from './types';

export const headlineStyles: Record<HeadlineLevel, string> = {
  1: 'text-2xl leading-7 font-black',
  2: 'text-xl leading-6 font-bold',
  3: 'text-lg leading-6 font-bold',
  4: 'text-base leading-5 font-bold'
};
